import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  ISatisfactionAnswersList,
  LastAnswerDateResponseDto,
  SatisfactionQuestionResponseDto
} from './+state/csat.declarations';

@Injectable({ providedIn: 'root' })
export class CsatModalService {
  readonly openModal: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly showConfirmBlock: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private readonly baseUrl = '/sdapi/profile/SatisfactionScore/';
  openModal$ = this.openModal.asObservable();
  showConfirmBlock$ = this.showConfirmBlock.asObservable()

  constructor(private readonly http: HttpClient) {
  }


  setOpenModal(show: boolean = true) {
    this.openModal.next(show);
  }

  getUserAnswerLastDate(): Observable<LastAnswerDateResponseDto> {
    return this.http.get<LastAnswerDateResponseDto>(`${this.baseUrl}UserAnswerLastDate`);
  }

  getQuestions(): Observable<SatisfactionQuestionResponseDto> {
    return this.http.get<SatisfactionQuestionResponseDto>(`${this.baseUrl}Questions`);
  }

  saveUserAnswer(userAnswer: ISatisfactionAnswersList): Observable<any> {
    return this.http.post<ISatisfactionAnswersList>(`${this.baseUrl}SaveResponse`,
      {
        satisfactionAnswersList: userAnswer.satisfactionAnswersList
      });
  }
}
